/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Email_Asset_InvalidInputs */

const en_error_email_asset_invalid = /** @type {(inputs: Error_Email_Asset_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The image cannot be used: only PNG, JPEG or GIF, up to 1 MB.`)
};

/**
* | output |
* | --- |
* | "The image cannot be used: only PNG, JPEG or GIF, up to 1 MB." |
*
* @param {Error_Email_Asset_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_email_asset_invalid = /** @type {((inputs?: Error_Email_Asset_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Email_Asset_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_email_asset_invalid(inputs)
});